function SkipLink() {
  return (
    <a
      href='#main-content'
      className='focus:bg-black focus:text-white sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-[100] focus:px-4 focus:py-2'
    >
      Skip to main content
    </a>
  )
}

export { SkipLink }
